import { DROP_ELEMENT } from "../../actions";
import ItemTypes from "../../constants/ItemTypes";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case DROP_ELEMENT:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          const layer = { ...old_layer };
          if (layer.layer_id === action.payload.layerId) {
            // Center of layer
            const layerCenterX = (layer.width / 2) * (state.preview_scale * 72),
              layerCenterY = (layer.height / 2) * (state.preview_scale * 72);

            if (action.payload.type === ItemTypes.TEXT) {
              layer.text_elements = layer.text_elements.map(
                (element, index) => {
                  if (index === action.payload.index) {
                    // Center of element
                    const elementCenterX =
                        (element.width / 2) * (state.preview_scale * 72),
                      elementCenterY =
                        (element.height / 2) * (state.preview_scale * 72),
                      // Center of element + drop position
                      elementCenterXPosition =
                        elementCenterX + action.payload.left,
                      elementCenterYPosition =
                        elementCenterY + action.payload.top,
                      // set position to this if it's close enough to center
                      centerXPosition = layer.width / 2 - element.width / 2,
                      centerYPosition = layer.height / 2 - element.height / 2;

                    let newLeftPos =
                        action.payload.left / (state.preview_scale * 72),
                      newTopPos =
                        action.payload.top / (state.preview_scale * 72);

                    // If drop position is within 15px of the center x guides, snap to center x
                    if (
                      layerCenterX - elementCenterXPosition <= 15 &&
                      layerCenterX - elementCenterXPosition >= -15 &&
                      action.payload.guidesVisible
                    ) {
                      newLeftPos = centerXPosition;
                    }

                    // If drop position is within 15px of the center x guides, snap to center x
                    if (
                      layerCenterY - elementCenterYPosition <= 15 &&
                      layerCenterY - elementCenterYPosition >= -15 &&
                      action.payload.guidesVisible
                    ) {
                      newTopPos = centerYPosition;
                    }

                    return {
                      ...element,
                      left_position: newLeftPos,
                      top_position: newTopPos,
                    };
                  } else {
                    return {
                      ...element,
                    };
                  }
                },
              );
            } else if (action.payload.type === ItemTypes.IMAGE) {
              layer.image_elements = layer.image_elements.map(
                (element, index) => {
                  if (index === action.payload.index) {
                    // Center of element
                    const elementCenterX =
                        (element.width / 2) * (state.preview_scale * 72),
                      elementCenterY =
                        (element.height / 2) * (state.preview_scale * 72),
                      // Center of element + drop position
                      elementCenterXPosition =
                        elementCenterX + action.payload.left,
                      elementCenterYPosition =
                        elementCenterY + action.payload.top,
                      // set position to this if it's close enough to center
                      centerXPosition = layer.width / 2 - element.width / 2,
                      centerYPosition = layer.height / 2 - element.height / 2;

                    let newLeftPos =
                        action.payload.left / (state.preview_scale * 72),
                      newTopPos =
                        action.payload.top / (state.preview_scale * 72);

                    // If drop position is within 15px of the center x guides, snap to center x
                    if (
                      layerCenterX - elementCenterXPosition <= 15 &&
                      layerCenterX - elementCenterXPosition >= -15 &&
                      action.payload.guidesVisible
                    ) {
                      newLeftPos = centerXPosition;
                    }

                    // If drop position is within 15px of the center x guides, snap to center x
                    if (
                      layerCenterY - elementCenterYPosition <= 15 &&
                      layerCenterY - elementCenterYPosition >= -15 &&
                      action.payload.guidesVisible
                    ) {
                      newTopPos = centerYPosition;
                    }

                    return {
                      ...element,
                      left_position: newLeftPos,
                      top_position: newTopPos,
                    };
                  } else {
                    return {
                      ...element,
                    };
                  }
                },
              );
            }
          }
          return layer;
        }),
      };

    default:
      return state;
  }
}
